import * as grs from 'grs'

export const BOLETO = 'boleto'
export const CARD = 'card'
export const PAYMENT_MODE_BOLETO = 'BOLETO'
export const PAYMENT_MODE_CREDIT_CARD = 'Credit'
export const PIX_PAYMENT_METHOD = 'PIX'
export const CREDIT_CARD_PAYMENT_METHOD = 'Credit card'
export const PSE_PAYMENT_METHOD = 'PSE'
export const GOOGLE_PAY_METHOD = 'GOOGLE_PAY'

export const getTransactionStatuses = () => {
    switch (window.COUNTRY_PURCHASE_FLOW) {
        case 'BR':
            return [grs.constants.STATUS_ACTIVE, grs.constants.STATUS_PASSED, grs.constants.STATUS_CANCELLED]
        default:
            return [
                grs.constants.STATUS_ACTIVE,
                grs.constants.STATUS_PASSED,
                grs.constants.STATUS_CANCELLED,
                grs.constants.STATUS_WAITING_LIST,
            ]
    }
}

export const getReservationPaymentMethod = reservation => {
    switch (reservation?.paymentMode) {
        case 'BOLETO':
            return BOLETO
        case 'DEBIT':
        case 'CREDIT':
        default:
            return CARD
    }
}

export const getPaymentMethod = creditCardId => {
    switch (creditCardId) {
        case PIX_PAYMENT_METHOD:
            return PIX_PAYMENT_METHOD
        case PSE_PAYMENT_METHOD:
            return PSE_PAYMENT_METHOD
        case GOOGLE_PAY_METHOD:
            return GOOGLE_PAY_METHOD
        default:
            return CREDIT_CARD_PAYMENT_METHOD
    }
}

export const isPaymentSelectionInvalid = (selectedPaymentMethod, locationData) => {
    if (!selectedPaymentMethod) return true
    // if we don't have location data, we can't check allowCard is allowed
    if (!locationData) return false

    const paymentType = getPaymentMethod(selectedPaymentMethod.id)

    return !locationData.allowCard && paymentType === CREDIT_CARD_PAYMENT_METHOD
}
